import React, { useEffect, useRef, useState } from 'react';

export default function ShootingStars({
  minSpeed = 10,
  maxSpeed = 30,
  minDelay = 4200,
  maxDelay = 8700,
  starColor = '#9E00FF',
  trailColor = '#2EB9DF',
  starWidth = 10,
  starHeight = 1,
  className = '',
}) {
  const [stars, setStars] = useState([]);
  const idRef = useRef(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    let mounted = true;

    const spawn = () => {
      if (!mounted) return;
      const id = idRef.current++;
      const startX = Math.random() * 100;
      const startY = Math.random() * 78;

      const dirX = Math.random() > 0.5 ? 1 : -1;
      const dirY = Math.random() > 0.5 ? 1 : -1;
      const dx = dirX * (16 + Math.random() * 40);
      const dy = dirY * (10 + Math.random() * 28);
      const angle = (Math.atan2(dy, dx) * 180) / Math.PI;

      const speed = minSpeed + Math.random() * Math.max(1, maxSpeed - minSpeed);
      const duration = 1.1 + (30 / speed) * 0.22;

      const star = {
        id,
        startX,
        startY,
        dx,
        dy,
        angle,
        duration,
      };

      setStars((prev) => [...prev, star]);

      window.setTimeout(() => {
        setStars((prev) => prev.filter((s) => s.id !== id));
      }, duration * 1000);

      const nextDelay = minDelay + Math.random() * Math.max(100, maxDelay - minDelay);
      timeoutRef.current = window.setTimeout(spawn, nextDelay);
    };

    timeoutRef.current = window.setTimeout(spawn, minDelay);

    return () => {
      mounted = false;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [minDelay, maxDelay, minSpeed, maxSpeed]);

  return (
    <div className={`shooting-stars-layer ${className}`.trim()} aria-hidden="true">
      {stars.map((s) => (
        <span
          key={s.id}
          className="shooting-star"
          style={{
            top: `${s.startY}%`,
            left: `${s.startX}%`,
            width: `${starWidth}px`,
            height: `${starHeight}px`,
            '--star-angle': `${s.angle}deg`,
            '--star-dx': `${s.dx}vw`,
            '--star-dy': `${s.dy}vh`,
            '--star-duration': `${s.duration}s`,
            '--star-color': starColor,
            '--trail-color': trailColor,
          }}
        />
      ))}
    </div>
  );
}
